<div class="rule-preview-tab">
  <div class="rule-preview-toggles">
    <div class="filter-group">
      <div class="filter-group-header">
        <div class="filter">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!dropPreviewService.globalSectionVisibility()['itemLibrary']"
              (click)="toggleSection('itemLibrary')"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Item Library">
              Every time you paste an item (<span class="keys"><span class="key">Ctrl</span><span class="keys-plus">+</span><span class="key">C</span></span> in game, then <span class="keys"><span class="key">Ctrl</span><span class="keys-plus">+</span><span class="key">V</span></span> anywhere in the tool), it is added to your Item Library and shown here when this section is enabled.
              <br /><br />Click a label to remove it; <span class="keys"><span class="key">Ctrl</span></span>-Click to jump to the rule that matched it; <span class="keys"><span class="key">Alt</span></span>-Click to clone in the Item Designer.
            </span>
          </span>
        </div>
      </div>

      <div class="filter-group-body">
        @if (settings.showItemLibraryExplainer()) {
          <div class="filter filter-property full-span item-library-explainer" style="padding-left: 42px;">
            <div class="info box reset-font">
              <div class="info-box-body">
                <div class="close-info-btn" (click)="dismissItemLibraryExplainer()">✕</div>
                <p>
                  Hover over any item in game, press <span class="keys"><span class="key">Ctrl</span><span class="keys-plus">+</span><span class="key">C</span></span>, then <span class="keys"><span class="key">Ctrl</span><span class="keys-plus">+</span><span class="key">V</span></span> anywhere in the tool to add it to your Item Library. Alternatively, design your own item.
                </p>
                <p><a class="remove-warning-link" (click)="dismissItemLibraryExplainer()">(dismiss)</a></p>
              </div>
            </div>
          </div>
        }

        <div class="filter filter-property full-span item-library-actions" style="padding-left: 42px;">
          <button type="button" class="btn" (click)="dropPreviewService.openItemDesigner()">
            Design Item
          </button>
          <button type="button" class="btn"
            [disabled]="itemLibraryService.items().length === 0"
            (click)="clearItemLibrary()">
            Clear Item Library
          </button>
        </div>
      </div>
    </div>

    <div class="filter-group">
      <div class="filter-group-header">
        <div class="filter">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!dropPreviewService.globalSectionVisibility()['randomLoot']"
              (click)="toggleRandomLoot()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Random Loot">
              Generates a pile of random items from our database so you can preview how your filter would label real drops.
              <br /><br />Optionally restrict by area level and pile size.
              <br /><br />Click a label to add that item to your Item Library; <span class="keys"><span class="key">Alt</span></span>-Click to clone in the Item Designer.
            </span>
          </span>
        </div>
      </div>

      <div class="filter-group-body">
        <div class="filter filter-property filter-padded-left random-loot-config" style="width: 100%;">
          <span class="filter-body">
            <span class="filter-title">Area Level</span>
            <span class="sep"></span>
            <input type="number" placeholder="Any" min="1" max="100" inputmode="numeric"
              class="form-control minmax random-loot-input"
              [(ngModel)]="randomLootAreaLevelInput"
              (change)="onRandomLootAreaLevelChange()">
          </span>
        </div>

        <div class="filter filter-property filter-padded-left random-loot-config" style="width: 100%;">
          <span class="filter-body">
            <span class="filter-title">Size</span>
            <span class="sep"></span>
            <input type="number" [placeholder]="randomLootDefaultSize" min="1" [max]="randomLootMaxSize" inputmode="numeric"
              class="form-control minmax random-loot-input"
              [disabled]="randomLootService.sizeInputDisabled()"
              [(ngModel)]="randomLootSizeInput"
              (change)="onRandomLootSizeChange()">
          </span>
        </div>

        <div class="filter filter-property filter-padded-left random-loot-config" style="width: 100%;">
          <span class="filter-body" style="width: 100%;">
            <div class="filter-title filter-label table-checkbox-group" style="border-left: 1px solid #634928 !important; width: 100% !important;">
              <span class="input-group-btn">
                <button class="btn toggle-btn"
                  [class.off]="!randomLootIncludeIdentified"
                  (click)="toggleRandomLootIncludeIdentified()"></button>
              </span>
              <div class="table-checkbox-label">
                <span class="filter-title-text">Include Identified</span>
                <div class="filter-tip">
                  <p>
                    When enabled, explicitly identified items are included in the random loot pile.
                    When disabled, only unidentified items and items without an identification state (e.g. currency) are returned.
                  </p>
                </div>
              </div>
            </div>
          </span>
        </div>

        <div class="filter filter-property full-span preview-action-btn" style="padding-left: 42px;">
          <button type="button" class="btn"
            [disabled]="randomLootService.generateDisabled()"
            (click)="generateLootPile()">
            {{ randomLootService.generating() ? 'Generating…' : 'Generate Loot Pile' }}
            @if (randomLootService.rateLimitWarning(); as rateLimitWarning) {
              <span class="icon icon-warning" [title]="rateLimitWarning"></span>
            }
          </button>
        </div>
      </div>
    </div>

    <div class="filter-group">
      <div class="filter-group-header">
        <div class="filter">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!dropPreviewService.allDropTierTogglesOn()" (click)="toggleAllDropTierSections()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Drop Tiers"></span>
          </span>
        </div>
      </div>

      <div class="filter-group-body">
        <div class="filter filter-property full-span">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!dropPreviewService.globalSectionVisibility()['currencyDropTiers']"
              (click)="toggleSection('currencyDropTiers')"></button>
          </span>
          <span class="filter-body">
            <div class="filter-title">
              <span class="filter-title-text">Currency Drop Tiers</span>
            </div>
          </span>
        </div>

        @if (poe1) {
          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!dropPreviewService.globalSectionVisibility()['divinationCardDropTiers']"
                (click)="toggleSection('divinationCardDropTiers')"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Divination Card Drop Tiers</span>
              </div>
            </span>
          </div>
        }

        <div class="filter filter-property full-span">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!dropPreviewService.globalSectionVisibility()['uniqueDropTiers']"
              (click)="toggleSection('uniqueDropTiers')"></button>
          </span>
          <span class="filter-body">
            <div class="filter-title">
              <span class="filter-title-text">Unique Drop Tiers</span>
            </div>
          </span>
        </div>

        <div class="filter filter-property full-span">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!dropPreviewService.globalSectionVisibility()['gold']"
              (click)="toggleSection('gold')"></button>
          </span>
          <span class="filter-body">
            <div class="filter-title">
              <span class="filter-title-text">Gold</span>
            </div>
          </span>
        </div>
      </div>
    </div>

    <div class="filter-group">
      <div class="filter-group-header">
        <div class="filter">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!dropPreviewService.globalSectionVisibility()['levelingPresetExamples']"
              (click)="toggleSection('levelingPresetExamples')"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Leveling Presets Examples"></span>
          </span>
        </div>
      </div>
    </div>

    <div class="filter-group">
      <div class="filter-group-header">
        <div class="filter">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!dropPreviewService.allCustomRuleTogglesOn()" (click)="toggleAllCustomRuleSections()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Custom Rules"></span>
          </span>
        </div>
      </div>

      <div class="filter-group-body">
        <div class="filter filter-property full-span">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!dropPreviewService.globalSectionVisibility()['customCosmeticRules']"
              (click)="toggleSection('customCosmeticRules')"></button>
          </span>
          <span class="filter-body">
            <div class="filter-title">
              <span class="filter-title-text">Custom Cosmetic Rules</span>
            </div>
          </span>
        </div>

        <div class="filter filter-property full-span">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!dropPreviewService.globalSectionVisibility()['customRules']"
              (click)="toggleSection('customRules')"></button>
          </span>
          <span class="filter-body">
            <div class="filter-title">
              <span class="filter-title-text">Custom Rules</span>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="rule-preview-column">
    <app-drop-preview
      [resizable]="true"
      [scrollable]="true"
      [showModeToggles]="false"
      [showBeamsToggle]="false"
      [showGlowToggle]="false"
      [showBackgroundToggle]="false" />
    <div class="rule-preview-bottom-toggles">
      <div class="rule-preview-bottom-toggles-left">
        <div class="rule-preview-beams-toggle filter filter-property">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!dropPreviewService.beams()" (click)="dropPreviewService.toggleBeams()"></button>
          </span>
          <span class="filter-body">
            <div class="filter-title">
              <span class="filter-title-text">Beams</span>
            </div>
          </span>
        </div>
        @if (poe2) {
          <div class="rule-preview-glow-toggle filter filter-property">
            <span class="input-group-btn">
              <button class="btn toggle-btn"
                [class.off]="dropPreviewService.forceGlow() === false || (dropPreviewService.forceGlow() === null && settings.labelGlow() !== 'always')"
                (click)="dropPreviewService.toggleForceGlow()"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Proximity label glow</span>
              </div>
            </span>
          </div>
        }
      </div>
    </div>
    <app-label-preview-background-picker
      class="rule-preview-bg-picker"
      [selectedId]="settings.labelPreviewBg()"
      (selected)="onPreviewBgSelect($event)" />
  </div>
</div>

